<template>
  <div style="color: #000" class="contents">
    <!--    <div class="home_tit">-->
    <!--      <div class="home_tit_top">-->
    <!--        <div class="home_tit_middle"></div>-->
    <!--        <div class="home_tit_right" @click="goTo(111)">-->
    <!--          <img src="../../assets/images/new/xiaoxibai.png" />-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div style="padding: 0 15px">
      <div style="" class="userBox">
        <div style="padding: 0px">
          <div class="user_con_top">
            <div class="header acea-row row-between-wrapper" style="">
              <div
                class="picTxt acea-row row-between-wrapper"
                style="display: flex; width: 100%"
              >
                <div class="pictrue" style="width: 50px; height: 50px">
                  <img
                    style="
                      width: 100%;
                      height: 100%;
                      border-radius: 50%;
                    "
                    src="@/assets/images/new/touxiang.png"
                  />
                </div>
                <div
                  class="text"
                  style="margin-left: 10px; width: auto; flex: 1"
                >
                  <div v-if="userInfo.is_auth" class="acea-row row-middle">
                    <div
                      style="font-weight: bold; font-size: 15px; color: #333;width: auto; margin-right: 5px;"
                      class="name line1"
                    >
                      {{ userInfo.realname }}
                    </div>
                    <img
                      style="vertical-align: middle"
                      width="60px"
                      :src="vipList[userInfo.vip]"
                      alt=""
                    />
                  </div>
                  <div
                    style="margin-top: 8px;font-weight: bold; font-size: 15px; color: rgb(51, 51, 51)"
                    v-if="userInfo.is_auth"
                  >
                    <span
                      style="
                        background: rgba(209, 209, 209, 0.2);
                        margin-right: 5px;
                        border-radius: 12px;
                        padding: 1px 4px;
                      "
                    >
                      +{{ wayUserMobileShow(userInfo.mobile) }}
                    </span>
                    <div
                      style="
                        position: relative;
                        top: -20px;
                        justify-content: center;
                        background: linear-gradient(
                          to bottom,
                          #fffbe6,
                          #ffe9a7,
                          #ffe9a7
                        );
                        color: #fd8535;
                        font-size: 11px;
                        border-radius: 20px;
                        display: flex;
                        align-items: center;
                        height: 25px;
                        float: right;
                        width: 80px;
                        font-weight: bold;
                      "
                    >
                      <img
                        style="width: 40px; height: 40px; margin-right: 3px"
                        src="@/assets/images/img/yuser.png"
                        alt=""
                        @click="wayToLink('/memmber_business')"
                      />
                    </div>
                  </div>

                  <div
                    style="margin-top: 8px;font-weight: bold; font-size: 15px; color: rgb(51, 51, 51);
                    display: flex;flex-direction: row;
                    justify-content: space-between;
"
                    v-else
                  >
                    <div>
                      <div
                        style="
                        margin-right: 5px;
                        border-radius: 12px;
                        padding: 1px 4px;
                      "
                      >
                        +{{ wayUserMobileShow(userInfo.mobile) }}
                      </div>

                      <img
                        style="vertical-align: middle"
                        width="60px"
                        :src="vipList[userInfo.vip]"
                        alt=""
                      />
                    </div>
                    <div
                      style="
                        position: relative;
                        justify-content: center;
                        background: linear-gradient(
                          to bottom,
                          #fffbe6,
                          #ffe9a7,
                          #ffe9a7
                        );
                        color: #fd8535;
                        font-size: 11px;
                        border-radius: 20px;
                        display: flex;
                        align-items: center;
                        height: 25px;
                        float: right;
                        width: 80px;
                        font-weight: bold;
                      "
                    >
                      <img
                        @click="wayToLink('/memmber_business')"
                        style="width: 40px; height: 40px; margin-right: 3px"
                        src="@/assets/images/img/nuser.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style="
          color: #ffffff;display: flex; align-items: center; min-height: 70px; margin-top: 10px; background: linear-gradient(rgb(53, 138, 244), rgb(32, 132, 255), rgb(53, 141, 249)); border-radius: 14px; justify-content: space-around; padding: 8px 4px;
          "
        >
          <div style="text-align: center; flex: 1">
            <p style="font-size: 12px; margin-bottom: 4px">
              {{ $t("m.yue") }}
            </p>
            <p>
              <span style="font-size: 14px; font-weight: bold">
                {{ userInfo.money }}
              </span>
            </p>
          </div>
          <div style="text-align: center; flex: 1">
            <p style="font-size: 12px; margin-bottom: 4px">
              {{ $t("m.shouyiguo") }}
            </p>
            <p>
              <span style="font-size: 14px; font-weight: bold">{{
                userInfo.usdt
              }}</span>
            </p>
          </div>
          <div style="text-align: center; flex: 1">
            <p style="font-size: 12px; margin-bottom: 4px">GMO余额</p>
            <p>
              <span style="font-size: 14px; font-weight: bold">{{
                userInfo.gmo || "0.00"
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div style="padding: 0 15px">
      <div class="user_con_mid" style="border-radius: 14px">
        <p class="user_con_mid_tit">{{ $t("m.xiangguan") }}</p>
        <div
          class="user_con_mid_block"
          style="display: flex; justify-content: space-around"
        >
          <div
            class="user_con_mid_line"
            v-for="(item, index) in moreList1"
            :key="index"
            @click="goTo(item.id)"
          >
            <img :src="item.icon" style="width: 30px" />
            <p class="">{{ $t("m.list3")[index] }}</p>
          </div>
        </div>
      </div>
      <div class="user_con_mid" style="border-radius: 14px">
        <!-- <p class="user_con_mid_tit">我的信息</p> -->
        <div class="user_con_mid_block">
          <div
            class="user_con_mid_line"
            v-for="(item, index) in conList"
            :key="item.id"
            @click="dianji(item.id)"
          >
            <img :src="item.img" />
            <p class="">{{ $t("m.list1")[index] }}</p>
          </div>
        </div>
      </div>
      <div class="user_con_mid" style="border-radius: 14px">
        <p class="user_con_mid_tit">其他功能</p>
        <div class="cell">
          <div
            class="cell-item"
            v-for="(item, index) in moreList"
            :key="item.id"
            @click="goTo(item.id)"
          >
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img :src="item.icon" />
              <div style="margin-left: 10px">{{ $t("m.list2")[index] }}</div>
            </div>
            <div style="height: 30px; width: 30px">
              <span class="iconfont icon-jiantou_liebiaoxiangyou_o"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 70px"></div>
  </div>
</template>

<script>
import $store from "../../store";
import local from "@/utils/local";
import { getUser, getMenuUser, getMyUserInfo } from "@api/user";
import { isWeixin } from "@utils";
// import SwitchWindow from "@components/SwitchWindow";
// import GeneralWindow from "@components/GeneralWindow";
const NAME = "User";

export default {
  name: NAME,
  components: {
    // SwitchWindow,
    // GeneralWindow
  },
  props: {},
  data: function() {
    return {
      imgs1: [
        require("../../assets/images/yhk/vip0.png"),
        require("../../assets/images/yhk/vip1.png"),
        require("../../assets/images/yhk/vip2.png"),
        require("../../assets/images/yhk/vip3.png"),
        require("../../assets/images/yhk/vip4.png"),
        require("../../assets/images/yhk/vip5.png"),
        require("../../assets/images/yhk/vip6.png"),
        require("../../assets/images/yhk/vip7.png"),
        require("../../assets/images/yhk/vip8.png"),
        require("../../assets/images/yhk/vip9.png")
      ],
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      timer: null,
      generalContent: {
        promoterNum: "",
        title: ""
      },
      funcList: {
        title: "",
        stimg: "/h5/img/yaoqing.04e5fd93.png",
        icon: require("@/assets/images/licai/yq1.png"),
        more: "更多服务",
        imgs: require("@/assets/images/yjt.png")
      },
      moreList1: [
        // {
        // 	id: 4,
        // 	text: '在线客服',

        // 	icon: require('@/assets/images/licai/di2.png'),
        // 	imgs: require('@/assets/images/yjt.png')
        // },
        {
          id: 44,
          text: "收益明细",
          icon: require("@/assets/images/img/wycz2.png"),
          imgs: require("@/assets/images/yjt.png")
        },
        // {
        //   id: 7,
        //   text: "我的资产",

        //   icon: require("@/assets/images/licai/di3.png"),
        //   imgs: require("@/assets/images/yjt.png")
        // },
        {
          id: 5,
          text: "我要充值",

          icon: require("@/assets/images/img/wycz1.png"),
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 6,
          text: "我要提现",

          icon: require("@/assets/images/img/wytx2.png"),
          imgs: require("@/assets/images/yjt.png")
        }
      ],
      moreList: [
        // {
        //   id: 2,
        //   icon: require("@/assets/images/licai/di1.png"),
        //   text: "安全保障",
        //   imgs: require("@/assets/images/yjt.png"),
        // },
        {
          id: 31,
          text: "提现记录",

          icon: require("@/assets/images/licai/di6.png"),
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 32,
          text: "充值记录",

          icon: require("@/assets/images/licai/di7.png"),
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 33,
          text: "兑换记录",
          icon: require("@/assets/images/licai/di8.png"),
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 138,
          text: "互转记录",
          icon: require("@/assets/images/licai/di13.png"),
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 134,
          text: "资产互转",
          icon: require("@/assets/images/licai/di13.png"),
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 135,
          text: "币种兑换",
          icon: require("@/assets/images/licai/di8.png"),
          imgs: require("@/assets/images/yjt.png")
        },
        // {
        // 	id: 1001,
        // 	text: '虚拟币购买',
        // 	icon: require('@/assets/images/licai/di15.png'),
        // 	imgs: require('@/assets/images/yjt.png')
        // },
        {
          id: 10,
          text: "支付密码",
          icon: require("@/assets/images/licai/di10.png"),
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 11,
          text: "登录密码",
          icon: require("@/assets/images/licai/di11.png"),
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 8,
          text: "退出登录",
          icon: require("@/assets/images/licai/di9.png"),
          imgs: require("@/assets/images/yjt.png")
        }
      ],
      conList: [
        {
          id: 0,
          img: require("@/assets/images/img/wycz2.png"),
          tit: "财务明细"
        },
        {
          id: 1,
          img: require("@/assets/images/img/cygn10.png"),
          tit: "我的团队"
        },
        {
          id: 2,
          img: require("@/assets/images/img/cygn11.png"),
          tit: "银行卡"
        },
        {
          id: 3,
          img: require("@/assets/images/img/cygn12.png"),
          tit: "实名认证"
        },
        {
          id: 4,
          img: require("@/assets/images/img/cygn13.png"),
          tit: "日利宝"
        },
        {
          id: 5,
          img: require("@/assets/images/img/cygn14.png"),
          tit: "我的投资"
        },
        {
          id: 6,
          img: require("@/assets/images/img/cygn15.png"),
          tit: "积分商城"
        },
        {
          id: 7,
          img: require("@/assets/images/img/cygn16.png"),
          tit: "邀请好友"
        }
      ],
      vipList: [
        require("@/assets/images/vip/vip0.png"),
        require("@/assets/images/vip/vip1.png"),
        require("@/assets/images/vip/vip2.png"),
        require("@/assets/images/vip/vip3.png"),
        require("@/assets/images/vip/vip4.png"),
        require("@/assets/images/vip/vip5.png"),
        require("@/assets/images/vip/vip6.png"),
        require("@/assets/images/vip/vip7.png"),
        require("@/assets/images/vip/vip8.png")
      ]
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  created() {
    let that = this;
    that.requ();
  },
  beforeDestroy() {
    console.log("销毁计时器");
    if (this.timer) {
      //如果定时器还在运行 或者直接关闭，不用判断
      clearInterval(this.timer); //关闭
    }
  },
  mounted: function() {
    this.isWeixin = isWeixin();
  },
  methods: {
    wayToLink(url) {
      this.$router.push({
        path: url
      });
    },
    qianBtn() {
      this.$router.push({
        path: "/Signln"
      });
    },
    requ() {
      getMyUserInfo().then(res => {
        this.userInfo = res.data.data;
      });
    },
    onWithdrawal() {
      this.$router.push({
        path: "/CzContent"
      });
    },
    onJF() {
      this.$router.push({
        path: "/member_transform"
      });
    },
    onRecharge() {
      this.$router.push({
        path: "/"
      });
    },
    shezhi() {
      this.$router.push({
        path: "/shezhi"
      });
    },
    goTo: function(lists) {
      if (lists == 8) {
        this.$store.commit("LOGOUT");
        let usernames = window.localStorage.getItem("zhanghao");
        let quhao = window.localStorage.getItem("quhao");
        let passwords = window.localStorage.getItem("mima");
        let fwq = window.localStorage.getItem("fwq");
        let lang = window.localStorage.getItem("lang");
        local.clear();
        window.localStorage.setItem("zhanghao", usernames);
        window.localStorage.setItem("quhao", quhao);
        window.localStorage.setItem("mima", passwords);
        window.localStorage.setItem("fwq", fwq);
        window.localStorage.setItem("lang", lang);
        this.$router.push({
          path: `/login`
        });
        return;
      }
      switch (lists) {
        case 1:
          this.$router.push({ name: "article_detail", query: { id: 16 } });
          break;
        case 2:
          this.$router.push({ name: "article_detail", query: { id: 22 } });
          break;
        case 4:
          let kf = $store.state.app.kf + "?token=" + $store.state.app.token;
          console.log(kf);
          plus.runtime.openURL(kf, function(res) {});
          break;
        case 5:
          this.onWithdrawal();
          break;
        case 6:
          this.$router.push({
            path: "/txCash"
          });
          break;
        case 7:
          this.$router.push({
            path: `/my-assets`,
            query: { tmoney: this.userInfo.tmoney }
          });
          break;
        case 10:
          this.$router.push({
            path: "/PayPass"
          });
          break;
        case 11:
          this.$router.push({
            path: "/LoginPass"
          });
          break;
        case 31:
          this.$router.push({
            path: "/withdrawal_record"
          });
          break;
        case 32:
          this.$router.push({
            path: "/deposit_record"
          });
          break;
        case 33:
          this.$router.push({
            path: "/dhlist"
          });
          break;
        case 111:
          this.$router.push({
            path: "/article"
          });
          break;
        case 134:
          this.$router.push({
            path: "/yuezhuan"
          });
          break;
        case 135:
          this.$router.push({
            path: "/zhuanhuan"
          });
          break;
        case 138:
          this.$router.push({
            path: "/yuezhuan_log"
          });
          break;
        case 1001:
          this.$router.push({
            path: "/xnblist"
          });

          break;
        case 44:
          this.$router.push({
            path: "/incomeDetail"
          });
          break;
        case 8:
          break;
        default:
          this.$router.push({
            path: "/"
          });
          break;
      }
    },
    dianji: function(id) {
      switch (id) {
        case 0:
          this.$router.push({
            path: "/moneyDetail"
          });
          break;
        case 1:
          this.$router.push({
            path: "/team"
          });
          break;
        case 7: //邀请好友
          this.$router.push({
            path: "/invitation"
          });
          break;
        case 3:
          this.$router.push({
            path: "/memmber_business"
          });
          break;
        case 4:
          this.$router.push({
            path: "/rilibaoindex"
          });
          break;
        case 6:
          this.$router.push({
            path: "/JfList"
          });
          break;
        case 5:
          this.$router.push({
            path: "/myInvest"
          });
          break;
        case 2:
          this.$router.push({
            path: "/bank"
          });
          break;
        default:
          this.$router.push({
            path: "/"
          });
          break;
      }
    },
    // 安全保障
    anquan: function() {
      this.$router.push({
        path: "/anquan"
      });
    },
    // 新手帮助
    news: function() {
      this.$router.push({
        path: "/news"
      });
    },
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.orderStatusNum = res.data.orderStatusNum;
      });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPagey(url) {
      this.$router.push({
        path: url
      });
    },
    goPages: function(index) {
      let url = this.MyMenus[index].wap_url;
      // 卡密激活
      if (url == "/user/user_coupon") {
        this.$router.push({
          path: "/user/get_coupon"
        });
        return;
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({
          mes: "您还不是客服！！"
        });
      }
      this.$router.push({
        path: this.MyMenus[index].wap_url
      });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    },
    wayUserMobileShow(val) {
      if (!val) {
        return "";
      }
      return val.slice(0, 2) + " " + val.slice(-11);
    }
  }
};
</script>

<style scoped lang="less">
.contents {
  background-image: url(../../assets/images/user_bank.png);
  background-repeat: no-repeat;
  background-size: 100% 380px;
}

.user {
  font-size: 14px;
  background-color: #fff;
  background-image: url(../../assets/images/bg233.png);
  background-repeat: no-repeat;
  background-size: 100% 200px;
}

.user_con_select {
  padding: 10px 0;

  margin-top: 8px;
  background-color: #ffffff;
}

.user_con_select_tit {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  padding: 8px 15px;
}

.user_con_select_list {
  display: flex;
  align-items: center;
  padding: 15px 15px;
  /* border-bottom: 1px solid #eee; */
}

.user_con_select_list img {
  margin-left: auto;
  width: 16px;
}

.user_con_select_list p {
  font-size: 14px;
  color: #000000;
}

.user_con_mid {
  margin-top: 12px;
  background-color: #fff;
  padding: 15px 0;
}

.user_con_mid_tit {
  font-size: 16px;
  color: #000;
  font-weight: bold;
  margin-bottom: 16px;
  padding: 0 15px;
}

.user_con_mid_block {
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  align-items: baseline;
  margin-top: 10px;
}

.home_tit {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
}

.home_tit_top {
  height: 50px;

  display: flex;
  align-items: center;
}

.home_swiper {
  width: 100%;
  height: 190px;
}

.home_swiper swiper-slide {
  width: 100%;
  height: 190px;
}

.home_swiper {
  height: 190px;
}

.banner_img {
  width: 100%;
  height: 190px;
}

.home_tit_left {
  width: 25%;
  display: flex;
  align-items: center;
}

.home_tit_left img {
  width: 23px;
  height: 23px;
}

.home_tit_left div {
  margin: 0 20px;
  color: #333;
  font-size: 16px;
}

.home_tit_middle {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  margin: 0 0px;
  color: #333;
  font-weight: bold;
  font-size: 22px;
}

.home_tit_middle img {
  width: 15px;
  height: 15px;
  margin-left: 7px;
}

.home_tit_right {
  padding-right: 10px;
  width: 50%;
  display: flex;
  align-items: center;
  color: #333;
  flex-direction: row-reverse;

  font-size: 15px;
  font-weight: bold;
}

.home_tit_right img {
  width: 22px;
  height: 22px;
  margin-left: 7px;
}

.yaoqing {
  width: 100%;
}

.user_con_mid_line {
  width: 25%;
  margin-bottom: 12px;
}

.user_con_mid_line img {
  width: 33px;
  display: block;
  margin: 0 auto;
}

.user_con_mid_line p {
  text-align: center;
  margin-top: 8px;
  font-size: 13px;
}

/* .user_con_top_but button{margin-left: 15px;} */
.user_con_top {
  border-radius: 6px;
  padding: 0px 0px;
  /* display: flex;
        align-items: center;
        justify-content: space-around; */
}

.user_con_top_but {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px !important;
}

.user_con_top_but button:first-child {
  width: 43px;
  height: 20px;
  background: #ffffff;
  border: 1px solid #cf4948;
  margin-right: 14px;
  border-radius: 10px;
  color: #cf4948;
  line-height: 18px;
  text-align: center;
}

.user_con_top_but button:last-child {
  width: 43px;
  height: 20px;
  background: #ffffff;
  border: 1px solid #1664fc;
  border-radius: 10px;
  color: #1664fc;
  text-align: center;
  line-height: 18px;
}

.user_con {
  width: 100%;
  /* background-color: #f2f1f6; */
  padding: 0px 0px;
  position: relative;
  /* padding-bottom: 70px !important; */
  top: -20px;
}

.footer-line-height {
  height: 1rem;
}

.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #334eec;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 14px;
  padding: 0 0.08rem;
  border: 1px solid #334eec;
}

.pictrue {
  position: relative;
}

.switch-h5 {
  margin-left: 0.2rem;
}

.binding {
  padding: 0.05rem 0.2rem;
  background-color: #4aa8fa;
  border-radius: 50px;
  font-size: 14px;
  border: 1px solid #4aa8fa;
  color: #ffffff;
  width: 50%;
  text-align: center;
  margin-top: 10px;
}
.userBox {
  background-color: #fff;
  padding: 10px;
  border-radius: 14px;
  margin-top: 35px;
}
.cell {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  .cell-item {
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 25px;
      height: 25px;
    }
  }
}
.row-middle {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
